import React, { useState, useEffect } from "react"
import { Checkbox, Select, Progress } from "antd"
import Button from 'components/Button'
import Drawer from 'components/Drawer'
import html2canvas from "html2canvas"
import jsPDF from "jspdf"
import autoTable from 'jspdf-autotable'
import "jspdf-autotable";
import {
    StyledDynamicText,
    FilterLabel,
    StyledFormItem,
    StyledDrawer,
} from "./Style/style"
import SuccessIcon from "components/icons/SuccessIcon"
import { PDFHeader } from "./components/PDFHeader"
import { PDFFooter } from "./components/PDFFooter"
import { useSelector } from "react-redux"
import { generateTopInstitutesPDF } from "./components/utils/generateTopInstitutesPDF"
import { generateStagesPDF } from "./components/utils/generateStagesPDF"
import { generateTopLocationsPDF } from "./components/utils/generateTopLocationsPDF"
import { generateInternshipRolesPDF } from "./components/utils/generateInternshipRolesPDF"

// Function to get dynamic label based on selected filter
const getDynamicLabel = (key, selectedFilter) => {
    if (key === "internshipRoles") {
        const filterName = selectedFilter === "JOBS" ? "Jobs" : 
                          selectedFilter === "INTERNSHIP" ? "Internship" : 
                          selectedFilter === "INTERNSHIP_PPO" ? "Internship + PPO" :
                          selectedFilter === "APPRENTICESHIP" ? "Apprenticeship" : 
                          selectedFilter === "PROJECTS" ? "Projects" : "Roles";
        return `No. of ${filterName} by Degree`;
    }
    return null; // Return null for other keys to use static labels
}

    const ExportPDF = ({ open, onClose, exportRefs, selectedFilter, isPermanentLocation }) => {
    const [step, setStep] = useState(1)
    const [selected, setSelected] = useState({})
    const [pdfBlob, setPdfBlob] = useState(null)
    const [loading, setLoading] = useState(false)
    const [selectedPassingYear, setSelectedPassingYear] = useState("2024")
    const [progress, setProgress] = useState(0)
    const [isDownload, setIsDownload] = useState(false)
    const [selectedCountForDownload, setSelectedCountForDownload] = useState(0)
    const corporateData = useSelector((state) => state?.auth?.corporateData)
    const locationChartData = useSelector((state) => state?.corporateDashboardPage2?.locationChartData)
    const instituteChartData = useSelector((state) => state?.corporateDashboardPage2?.instituteChartData)
    const degreeChartData = useSelector((state) => state?.corporateDashboardPage2?.degreeChartData)
    const stagesChartData = useSelector((state) => state?.corporateDashboardPage2?.stagesChartData)

    // Check data availability for each chart type
    const hasStagesData = stagesChartData && (
        (stagesChartData.scheduledCount || 0) > 0 ||
        (stagesChartData.offeredCount || 0) > 0 ||
        (stagesChartData.joinedCount || 0) > 0 ||
        (stagesChartData.leftCount || 0) > 0
    )

    const hasLocationData = locationChartData?.locationBarChart?.some(item => 
        item.location && item.location.trim() !== "" && (item.hired || 0) > 0
    )

    const hasInstituteData = instituteChartData?.instituteBarChart?.some(item => 
        item.institute && item.institute !== "" && (
            (item.hired || 0) > 0 || 
            (item.applicants || 0) > 0
        )
    )

    const hasDegreeData = degreeChartData?.degreeBarChart?.some(item => 
        item.degree && item.degree !== "" && (
            (item.floated || 0) > 0 || 
            (item.active || 0) > 0 || 
            (item.closed || 0) > 0
        )
    )

    // Dynamic GRAPH_LIST based on selectedFilter and data availability
    const GRAPH_LIST = [
        { key: "internshipRoles", label: getDynamicLabel("internshipRoles", selectedFilter), hasData: hasDegreeData },
        { key: "stages", label: "Stages", hasData: hasStagesData },
        { key: "topLocations", label: "Top 10 locations", hasData: hasLocationData },
        { key: "topInstitutes", label: "Top 10 Institutes", hasData: hasInstituteData },
    ]

    const selectedCount = Object.values(selected).filter(Boolean).length

    // Cleanup function to revoke blob URL when component unmounts or new generation starts
    const cleanupBlob = () => {
        if (pdfBlob) {
            // Create a temporary URL to revoke the old blob
            const tempUrl = URL.createObjectURL(pdfBlob)
            URL.revokeObjectURL(tempUrl)
        }
    }

    // Reset step to 1 when drawer opens
    useEffect(() => {
        if (open) {
            setStep(1)
        }
    }, [open])

    // Cleanup blob when component unmounts
    useEffect(() => {
        return () => {
            cleanupBlob()
        }
    }, [])

    // Select All
    const handleSelectAll = (checked) => {
        const obj = {}
        GRAPH_LIST.forEach(i => {
            obj[i.key] = checked && i.hasData
        })
        setSelected(obj)
    }

    // Individual select
    const handleChange = (key, value) => {
        const item = GRAPH_LIST.find(i => i.key === key)
        if (!item?.hasData && value) return // Prevent selecting items with no data
        setSelected(prev => ({ ...prev, [key]: value }))
    }

    // const generateStagesPDF = async (pdf) => {
    //     const element = exportRefs.stages?.current
    //     if (!element) return

    //     const startY = await PDFHeader({ pdf, corporateData })

    //     pdf.setFontSize(14)
    //     pdf.setFont(undefined, "bold")
    //     pdf.text("Stages", 15, startY)

    //     pdf.setFontSize(10)
    //     pdf.setFont(undefined, "normal")
    //     pdf.text(
    //         "Data below shows the indication of stages of the candidates",
    //         15,
    //         startY + 6
    //     )

    //     const chartElement = element.querySelector(".stages-chart-export")

    //     const canvas = await html2canvas(chartElement, {
    //         scale: 2,
    //         useCORS: true,
    //     })

    //     const imgData = canvas.toDataURL("image/png")

    //     const imgWidth = 300
    //     const imgHeight = (canvas.height * imgWidth) / canvas.width

    //     pdf.addImage(imgData, "PNG", 15, startY + 12, imgWidth, imgHeight)
    //     let currentY = startY + 12 + imgHeight + 10
    //     // Get dynamic stages data from the component or use default fallback
    //     const stagesData = exportRefs.stagesData?.current || [
    //         { stage: "Scheduled", count: 9037 },
    //         { stage: "Offered", count: 5083 },
    //         { stage: "Joined", count: 2992 },
    //         { stage: "Left", count: 368 },
    //     ]

    //     pdf.autoTable({
    //         startY: currentY,
    //         columns: [
    //             { header: "", dataKey: "roles" },
    //             { header: "Roles", dataKey: "count" },
    //         ],
    //         body: stagesData.map(item => ({ roles: item.stage, count: item.count })),
    //         theme: "grid",
    //         styles: { fontSize: 10 },
    //         headStyles: {
    //             fillColor: [220, 220, 220],
    //             textColor: 0,
    //             fontStyle: "bold",
    //         },
    //         columnStyles: {
    //             roles: { cellWidth: 50 },   // smaller column
    //             count: { cellWidth: 120 }   // larger column
    //         },
    //     })


    //     await PDFFooter({ pdf })
    // }
    {/*const generateTopLocationsPDF = async (pdf) => {
        const element = exportRefs.topLocations?.current
        if (!element) return

        // HEADER
        const startY = await PDFHeader({ pdf, corporateData })

        // TITLE
        pdf.setFontSize(14)
        pdf.setFont(undefined, "bold")
        pdf.text("Top 10 location (Current Location)", 15, startY)

        pdf.setFontSize(10)
        pdf.setFont(undefined, "normal")
        pdf.text(
            "Data below shows the indication of company location by the amount spent",
            15,
            startY + 6
        )

        // 📊 CAPTURE ONLY CHART PART (important)
        const chartElement = element.querySelector("canvas")?.parentNode
        const canvas = await html2canvas(chartElement, {
            scale: 2, useCORS: true,
        })
        const imgData = canvas.toDataURL("image/png")

        const imgWidth = 200
        const imgHeight = (canvas.height * imgWidth) / canvas.width

        pdf.addImage(imgData, "PNG", 15, startY + 12, imgWidth, imgHeight)

        let currentY = startY + 12 + imgHeight + 10

        // 🔹 Get dynamic table data from locationChartData
        const locationBarData = locationChartData?.locationBarChart || []
        const validLocations = locationBarData.filter(item => item.location && item.location !== "")
        const tableData = validLocations.slice(0, 10).map(item => {
            const men = item.men || 0
            const women = item.women || 0
            return [
                item.location || "Unknown",
                item.hires || 0,
                `Men: ${men}`,
                `Women: ${women}`
            ]
        })

        // 🔹 TABLE
        pdf.autoTable({
            startY: currentY,
            head: [["Cities", "Hires", "Gender", ""]],
            body: tableData,
            theme: "grid",
            styles: { fontSize: 10 },
            headStyles: {
                fillColor: [220, 220, 220],
                textColor: 0,
                fontStyle: "bold",
            },
            didParseCell: function (data) {
        if (data.column.index >= 2) {
            // push text right for circle
            data.cell.styles.cellPadding = { left: 7, top: 2, bottom: 2 }
        }
    },

    didDrawCell: function (data) {
        if (data.column.index >= 2 && data.cell.section === "body") {
            const { x, y, height } = data.cell
            const text = data.cell.raw

            const circleX = x + 3
            const circleY = y + height / 2
            const radius = 1

            if (text.startsWith("Men")) {
                pdf.setFillColor(0, 27, 72) // #001B48
                pdf.circle(circleX, circleY, radius, "F")
            }

            if (text.startsWith("Women")) {
                pdf.setFillColor(1, 138, 190) // #018ABE
                pdf.circle(circleX, circleY, radius, "F")
            }
        }
    }
        })

        // FOOTER
        await PDFFooter({ pdf })

    }*/}
    {/* const generateTopInstitutesPDF = async (pdf) => {
        const element = exportRefs.topInstitutes?.current
        if (!element) return


        // HEADER
        const startY = await PDFHeader({ pdf, corporateData })

        // TITLE
        pdf.setFontSize(14)
        pdf.setFont(undefined, "bold")
        pdf.text("Top 10 Institute", 15, startY)

        pdf.setFontSize(10)
        pdf.setFont(undefined, "normal")
        pdf.text(
            "Data below shows the indication of company location by the amount spent",
            15,
            startY + 6
        )

        // 📊 Capture ONLY chart area
        const chartElement = element.querySelector("canvas")?.parentNode
        const canvas = await html2canvas(chartElement, {
            scale: 3,
            useCORS: true,
        })

        const imgData = canvas.toDataURL("image/png")

        const imgWidth = 180
        const imgHeight = (canvas.height * imgWidth) / canvas.width

        pdf.addImage(imgData, "PNG", 15, startY + 12, imgWidth, imgHeight)

        let currentY = startY + 12 + imgHeight + 10

        // 🔹 Get dynamic table data from instituteChartData
        const instituteBarData = instituteChartData?.instituteBarChart || []
        const validInstitutes = instituteBarData.filter(item => item.institute && item.institute !== "")
        const tableData = validInstitutes.slice(0, 10).map(item => {
            const genderAnalysis = item.instituteGenderAnalysis || {}
            const men = genderAnalysis.men || 0
            const women = genderAnalysis.women || 0
            return [
                item.institute || "Unknown Institute",
                item.hired || 0,
                item.applicants || 0,
                `Men: ${men}`,
                `Women: ${women}`
            ]
        })

        // 🔹 TABLE
        pdf.autoTable({
    startY: currentY,
    head: [["Institutes", "Hires", "Applicants", "Gender", ""]],
    body: tableData,
    theme: "grid",
    styles: { fontSize: 10 },
    headStyles: {
        fillColor: [220, 220, 220],
        textColor: 0,
        fontStyle: "bold",
    },

    didParseCell: function (data) {
        // move header text slightly right
        if (data.section === "head" && (data.column.index === 1 || data.column.index === 2)) {
            data.cell.styles.cellPadding = { left: 7, top: 2, bottom: 2 }
        }

        // move gender text right for circle
        if (data.section === "body" && data.column.index >= 3) {
            data.cell.styles.cellPadding = { left: 7, top: 2, bottom: 2 }
        }
    },

    didDrawCell: function (data) {

        const { x, y, height } = data.cell
        const circleX = x + 3
        const circleY = y + height / 2
        const radius = 1

        // HEADER CIRCLES
        if (data.section === "head") {

            // Hires
            if (data.column.index === 1) {
                pdf.setFillColor(0, 27, 72) // #001B48
                pdf.circle(circleX, circleY, radius, "F")
            }

            // Applicants
            if (data.column.index === 2) {
                pdf.setFillColor(151, 202, 219) // #97CADB
                pdf.circle(circleX, circleY, radius, "F")
            }
        }

        // BODY CIRCLES
        if (data.section === "body" && data.column.index >= 3) {
            const text = data.cell.raw

            if (text?.startsWith("Men")) {
                pdf.setFillColor(0, 27, 72) // #001B48
                pdf.circle(circleX, circleY, radius, "F")
            }

            if (text?.startsWith("Women")) {
                pdf.setFillColor(1, 138, 190) // #018ABE
                pdf.circle(circleX, circleY, radius, "F")
            }
        }
    }
})

        // FOOTER
        await PDFFooter({ pdf })
    } */}

    // Custom PDF generation for internshipRoles (landscape, paginated)
   {/*} const generateInternshipRolesPDF = async (pdf) => {
        // Get dynamic label for the title
        const dynamicLabel = getDynamicLabel("internshipRoles", selectedFilter);
        const filterName = selectedFilter === "JOBS" ? "Jobs" : 
                          selectedFilter === "INTERNSHIP" ? "Internship" : 
                          selectedFilter === "INTERNSHIP_PPO" ? "Internship + PPO" :
                          selectedFilter === "APPRENTICESHIP" ? "Apprenticeship" : 
                          selectedFilter === "PROJECTS" ? "Projects" : "Roles";
        
        // Read degree data dynamically from ref (set by DegreeAnalysis)
        const allDegreeData = (exportRefs.internshipRolesData?.current || []).map(item => ({
            degree: item.degree,
            floated: item.floated,
            active: item.active,
            closed: item.closed,
            men: item.degreeGenderAnalysis?.men || 0,
            women: item.degreeGenderAnalysis?.women || 0
        }))

        if (allDegreeData.length === 0) return

        // Paginate: max 10 degrees per page
        const ITEMS_PER_PAGE = 10
        const totalPages = Math.ceil(allDegreeData.length / ITEMS_PER_PAGE)

        for (let page = 0; page < totalPages; page++) {
            if (page > 0) {
                pdf.addPage("a4", "landscape")
            }

            const pageData = allDegreeData.slice(page * ITEMS_PER_PAGE, (page + 1) * ITEMS_PER_PAGE)
            const startY = await PDFHeader({ pdf, corporateData })

            pdf.setFontSize(14)
            pdf.setFont(undefined, "bold")
            pdf.text(
                totalPages > 1
                    ? `${dynamicLabel} (${page + 1}/${totalPages})`
                    : dynamicLabel,
                15, startY
            )

            pdf.setFontSize(10)
            pdf.setFont(undefined, "normal")
            pdf.text(`Data below shows the indication of ${filterName.toLowerCase()} roles distribution by degree`, 15, startY + 6)

            let currentY = startY + 15

            // Set chart range to match this page's data, then capture
            const setChartRange = exportRefs.setChartRange?.current
            if (setChartRange) {
                setChartRange({ start: page * ITEMS_PER_PAGE, count: pageData.length })
                // Wait for React re-render and chart animation
                await new Promise(resolve => setTimeout(resolve, 800))
            }

            const element = exportRefs.internshipRoles?.current
            if (element) {
                const canvas = await html2canvas(element, { scale: 2 })
                const imgData = canvas.toDataURL("image/png")
                const pageWidth = pdf.internal.pageSize.getWidth()
                const imgWidth = pageWidth - 30
                const imgHeight = (canvas.height * imgWidth) / canvas.width
                const reducedHeight = imgHeight * 0.8
                pdf.addImage(imgData, "PNG", 15, currentY - 5, imgWidth, reducedHeight)
                currentY += reducedHeight + 2
            }

            addInternshipRolesTablesForPage(pdf, currentY, pageData)

            await PDFFooter({ pdf })
        }

        // Reset chart range after export so UI returns to normal
        const setChartRangeReset = exportRefs.setChartRange?.current
        if (setChartRangeReset) {
            setChartRangeReset(null)
        }
    }

    // Add tables for a page of degree data (dynamic columns)
    const addInternshipRolesTablesForPage = (pdf, startY, degreeData) => {
        const pageWidth = pdf.internal.pageSize.getWidth()
        const margin = 10
        const availableWidth = pageWidth - (margin * 2)
        const statusColWidth = 22
        const dataColWidth = Math.floor((availableWidth - statusColWidth) / degreeData.length)

        // Build dynamic headers
        const roleHeaders = [
            { header: 'Status', dataKey: 'status' },
            ...degreeData.map((d, i) => ({ header: d.degree, dataKey: `c${i}` }))
        ]

        // Build role data rows dynamically
        const roleDataRows = [
            { status: 'Floated', ...degreeData.reduce((a, d, i) => ({ ...a, [`c${i}`]: d.floated }), {}) },
            { status: 'Active', ...degreeData.reduce((a, d, i) => ({ ...a, [`c${i}`]: d.active }), {}) },
            { status: 'Closed', ...degreeData.reduce((a, d, i) => ({ ...a, [`c${i}`]: d.closed }), {}) }
        ]

        // Build column styles dynamically
        const roleColumnStyles = { status: { cellWidth: statusColWidth, halign: 'left' } }
        degreeData.forEach((_, i) => {
            roleColumnStyles[`c${i}`] = { cellWidth: dataColWidth, halign: 'center' }
        })

        // Role status table
        pdf.autoTable({
            startY: startY,
            columns: roleHeaders,
            body: roleDataRows,
            theme: 'grid',
            styles: { fontSize: 8, textColor: [40, 40, 40], cellPadding: 2 },
            headStyles: {
                fillColor: [238, 238, 238],
                textColor: 0,
                fontStyle: 'bold',
                halign: 'center',
            },
            columnStyles: roleColumnStyles,
            tableWidth: 'wrap',
            margin: { left: margin, right: margin },
            didParseCell: function (data) {
                if (data.column.dataKey === 'status') {
                    data.cell.styles.fillColor = [238, 238, 238]
                    data.cell.styles.fontStyle = 'bold'
                    data.cell.styles.cellPadding = { left: 8 }
                    data.cell.styles.valign = 'middle'
                }
            },
            didDrawCell: function (data) {
                if (data.column.dataKey === 'status' && data.cell.section === 'body') {
                    const { x, y, height } = data.cell
                    const status = data.cell.raw
                    let color = [0, 0, 0]
                    if (status === 'Floated') color = [0, 31, 84]
                    if (status === 'Active') color = [173, 232, 244]
                    if (status === 'Closed') color = [180, 180, 180]
                    pdf.setFillColor(...color)
                    pdf.circle(x + 3, y + height / 2, 1.2, 'F')
                }
            }
        })

        let currentY = pdf.autoTable.previous.finalY + 6

        // Gender table column styles
        const genderColumnStyles = { 0: { cellWidth: statusColWidth, halign: 'left', fontStyle: 'bold' } }
        degreeData.forEach((_, i) => {
            genderColumnStyles[i + 1] = { cellWidth: dataColWidth, halign: 'center' }
        })

        // Gender table
        pdf.autoTable({
    startY: currentY,
    body: [
        ['Men', ...degreeData.map(d => d.men)],
        ['Women', ...degreeData.map(d => d.women)]
    ],
    showHead: false,
    theme: 'grid',
    styles: { fontSize: 8, textColor: [40, 40, 40], cellPadding: 2 },
    columnStyles: genderColumnStyles,
    tableWidth: 'wrap',
    margin: { left: margin, right: margin },

    didParseCell: function (data) {
        if (data.column.index === 0) {
            // move text slightly right and vertically center
            data.cell.styles.cellPadding = { left: 7, top: 2, bottom: 2 }
            data.cell.styles.valign = "middle"
        }
    },

    didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.section === 'body') {
            const { x, y, height } = data.cell
            const value = data.cell.raw

            const radius = 1 // ≈ 3mm diameter (~12px)
            const circleX = x + 3
            const circleY = y + height / 2

            if (value === 'Men') {
                pdf.setFillColor(0, 27, 72) // #001B48
                pdf.circle(circleX, circleY, radius, 'F')
            }

            if (value === 'Women') {
                pdf.setFillColor(1, 138, 190) // #018ABE
                pdf.circle(circleX, circleY, radius, 'F')
            }
        }
    }
})
    }*/}

    // PDF GENERATION
    const generatePDF = async () => {
        setLoading(true)
        setProgress(20)
        
        // Cleanup any existing blob and reset pdfBlob to prevent downloading old files
        cleanupBlob()
        setPdfBlob(null)

        let progressInterval

        try {
            progressInterval = setInterval(() => {
                setProgress(prev => (prev < 80 ? prev + 20 : prev))
            }, 1000)

            const selectedGraphs = GRAPH_LIST.filter(item => selected[item.key])
            const total = selectedGraphs.length

            if (total === 0) return

            const pdf = new jsPDF("p", "mm", "a4")

            for (let i = 0; i < selectedGraphs.length; i++) {
                const item = selectedGraphs[i]

                // 👉 Add new page for all except first
                if (i !== 0) {
                    if (item.key === "internshipRoles") {
                        pdf.addPage("a4", "landscape")
                    } else {
                        pdf.addPage("a4", "portrait")
                    }
                } else {
                    // 👉 FIRST PAGE FIX
                    if (item.key === "internshipRoles") {
                        pdf.deletePage(1)
                        pdf.addPage("a4", "landscape")
                    }
                }

                // 👉 Call correct generator
                if (item.key === "internshipRoles") {
                    await generateInternshipRolesPDF({
                        pdf,
                        corporateData,
                        selectedFilter,
                        exportRefs: {
                            internshipRoles: exportRefs.internshipRoles,
                            internshipRolesData: exportRefs.internshipRolesData,
                            setChartRange: exportRefs.setChartRange
                        },
                        getDynamicLabel
                    })
                } else if (item.key === "stages") {
                    await generateStagesPDF({
                        pdf,
                        corporateData,
                        stagesRef: exportRefs.stages,
                        stagesData: exportRefs.stagesData?.current
                    })
                } else if (item.key === "topLocations") {
                    await generateTopLocationsPDF({
                        pdf,
                        corporateData,
                        locationChartData,
                        topLocationsRef: exportRefs.topLocations,
                        locationName: isPermanentLocation ? "Permanent Location" : "Current Location"
                    })
                } else if (item.key === "topInstitutes") {
                    await generateTopInstitutesPDF({
                        pdf,
                        corporateData,
                        instituteChartData,
                        topInstitutesRef: exportRefs.topInstitutes,
                    })
                } else {
                    const element = exportRefs[item.key]?.current
                    if (!element) continue

                    const startY = await PDFHeader({ pdf, corporateData })

                    const canvas = await html2canvas(element, { scale: 2 })
                    const imgData = canvas.toDataURL("image/png")

                    const pgW = pdf.internal.pageSize.getWidth()
                    const pgH = pdf.internal.pageSize.getHeight()
                    const maxW = pgW - 30
                    const maxH = pgH * 0.55
                    let iw = maxW
                    let ih = (canvas.height * iw) / canvas.width
                    if (ih > maxH) {
                        ih = maxH
                        iw = (canvas.width * ih) / canvas.height
                    }
                    pdf.addImage(imgData, "PNG", 15, startY + 5, iw, ih)

                    await PDFFooter({ pdf })
                }
            }

            const blob = pdf.output("blob")
            setPdfBlob(blob)

            setProgress(100)
        } catch (error) {
            console.error('Error generating PDF:', error)
            setProgress(0)
        } finally {
            clearInterval(progressInterval)
            setLoading(false)
        }
    }

    const handleDownload = () => {
        if (!pdfBlob) return

        const url = URL.createObjectURL(pdfBlob)
        const a = document.createElement("a")
        a.href = url
        a.download = "Corporate_Dashboard.pdf"
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(url)
        setIsDownload(false)
    }

    const handleNext = async () => {
        if (step === 1) setStep(2)
        else if (step === 2) {
            setSelectedCountForDownload(selectedCount)
            setStep(3)
            generatePDF()
        }
    }

    const download = () => {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    alignItems: 'center',
                    gap: '2rem',
                }}
            >
                <div style={{ flex: 1 }}>
                    <StyledDynamicText>
                        Exporting {selectedCountForDownload} {selectedCountForDownload === 1 ? 'Graph' : 'Graphs'} ({progress}% Completed)
                    </StyledDynamicText>
                    <Progress
                        percent={progress}
                        status={progress < 100 ? 'active' : 'success'}
                    />
                </div>
                <Button.Primary
                    text={'Download'}
                    height="38px"
                    onClick={() => handleDownload()}
                    disabled={!pdfBlob}
                />
            </div>
        )
    }

    const handleClose = () => {
        setSelected({})
        setLoading(false)
        if (step === 3) {
            setIsDownload(true)
        } else {
            setPdfBlob(null)
            setProgress(0)
        }
        onClose()
    }

    return (
        <>
            <Drawer
                width="600px"
                style={{
                    fontFamily: "Plus Jakarta Sans",
                    fontWeight: 400,
                    fontStyle: "normal",
                    fontSize: "14px",
                    lineHeight: "25px",
                    letterSpacing: "0%",
                }}
                title={`Export Graphs ${selectedCount
                    ? `(${selectedCount} graph${selectedCount > 1 ? "s" : ""} selected)`
                    : ""
                    }`}
                visible={open}
                onClose={handleClose}
                closable={true}
                content={
                    step === 1 ? (
                        <div>
                            <p>Select the graphs you want in your PDF export</p>

                            <Checkbox
                                checked={selectedCount === GRAPH_LIST.filter(item => item.hasData).length}
                                onChange={(e) => handleSelectAll(e.target.checked)}
                            >
                                Select all
                            </Checkbox>

                            <div style={{ marginTop: 10 }}>
                                {GRAPH_LIST.map(item => (
                                    <div key={item.key} style={{ marginTop: 8 }}>
                                        <Checkbox
                                            checked={selected[item.key] || false}
                                            onChange={(e) => handleChange(item.key, e.target.checked)}
                                            disabled={!item.hasData}
                                        >
                                            {item.label}
                                            {!item.hasData && (
                                                <span style={{ color: '#999', marginLeft: 8, fontSize: '12px' }}>
                                                    (No data)
                                                </span>
                                            )}
                                        </Checkbox>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ) : step === 2 ? (
                        <div>
                            <div
                                style={{
                                    height: 300,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                }}
                            >
                                <SuccessIcon width={100} height={100} />
                                <StyledDynamicText align="center">
                                    Preparing export for
                                    <br /> <b>
                                        {selectedCount}{" "}{selectedCount === 1 ? "graph" : "graphs"} selected
                                    </b>
                                </StyledDynamicText>
                            </div>
                            {/* <div>
                                <StyledDynamicText mb={'20px'} mt={'20px'}>
                                    Would you like a comparison between the selected
                                    batch {' '}
                                    <b>&quot;&nbsp;{selectedPassingYear}&quot;&nbsp;</b> with another specific batch?
                                </StyledDynamicText>
                            </div>
                            <div style={{
                                display: 'flex',
                                width: '100%',
                                alignItems: 'center',
                                gap: 10,
                            }}>
                                <FilterLabel whiteSpace="pre">
                                    {' '}
                                    Selected Passing Year
                                </FilterLabel>
                                <StyledFormItem
                                    style={{ width: '180px', marginBottom: '15px' }}
                                >
                                    <Select
                                        value={selectedPassingYear}
                                        onChange={(value) => setSelectedPassingYear(value)}
                                        style={{
                                            width: '180px',
                                            fontFamily: 'Plus Jakarta Sans',
                                            fontSize: '14px'
                                        }}
                                    >
                                        <Select.Option value="2024">2024</Select.Option>
                                        <Select.Option value="2023">2023</Select.Option>
                                        <Select.Option value="2022">2022</Select.Option>
                                        <Select.Option value="2021">2021</Select.Option>
                                        <Select.Option value="2020">2020</Select.Option>
                                    </Select>
                                </StyledFormItem>
                            </div> */}
                        </div>
                    ) : (
                        <div>
                            <>
                                <div
                                    style={{
                                        height: 300,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                    }}
                                >
                                    <SuccessIcon width={100} height={100} />
                                    <StyledDynamicText align="center">
                                        <b>Successful!</b>
                                        <br />
                                        Exporting in Progress
                                    </StyledDynamicText>
                                </div>
                            </>
                        </div>
                    )
                }
                footer={
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                        {step === 3 ? (
                            <>
                                <Button text="Close" onClick={handleClose} />
                                <Button.Primary
                                    text="Close"
                                    onClick={handleClose}
                                />
                            </>
                        ) : (
                            <Button.Primary
                                text={step === 1 ? "Next" : "Generate"}
                                onClick={handleNext}
                                disabled={step === 1 && selectedCount === 0}
                            />
                        )}
                    </div>
                }
            />
            <StyledDrawer
                width="100%"
                placement="right"
                closable={true}
                visible={isDownload}
                content={download()}
                overflowBody={'hidden'}
                onClose={() => {
                    // Close download drawer without triggering main drawer logic
                    setIsDownload(false)
                }}
            />
        </>
    )

}

export default ExportPDF
